import * as Environment from "../base/Environment.js";

import {Site, SiteSection} from "./Site.js";
import {Navigation} from "./Navigation.js";

import {Gallery, GallerySection} from "./GallerySection.js";
import {Product} from "./DemandCalculatorModel.js";

//
// DemandCalculator extends SiteSection
//

export const DemandCalculator = function (context) {
	SiteSection.apply (this, arguments);
	
	DemandCalculator.sharedInstance = this;
	
};

window.DemandCalculator = DemandCalculator;

DemandCalculator.prototype = Object.create (SiteSection.prototype);

DemandCalculator.prototype.parameters = {
	isWaterPermeable: true,
	
	stoneWidth: 300,
	stoneLength: 300,
	
	jointsWidth: 40, // 5,
	jointsDepth: 30, // 20,
	
	height: 65,
	thickness: 150, // 15,
	
	area: 100
	
};

DemandCalculator.prototype.takeElement = async function (element) {
	SiteSection.prototype.takeElement.apply (this, arguments);
	
	const mainElement = this.mainElement = document.body.querySelector ("main");
	const backgroundElement = this.backgroundElement = document.body.querySelector (".background-shape-container");
	
	const intro = this.intro = element.querySelector (".demand-calculator-intro");
	const groupButtons = intro.querySelectorAll (".button");
	groupButtons.forEach (groupButton => {
		groupButton.addEventListener ("click", this.selectGroup.bind (this));
		
	});
	
	const content = this.content = element.querySelector (".demand-calculator-content");
	content.querySelector (".back-button").addEventListener ("click", event => {
		this.reset ();
		
	});
	content.querySelectorAll ("label:not(.disabled)").forEach (label => {
		label.addEventListener ("click", event => {
			this.selectGroup ();
			
			const gallery = DemandCalculatorGallery.sharedInstance;
			gallery.jumpToInput (label.getAttribute ("for"));
			
		});
		
	});
	
	const overlay = this.overlay = element.querySelector (".demand-calculator-overlay");
	document.body.appendChild (overlay);
	overlay.querySelector (".close-button").addEventListener ("click", this.closeOverlay.bind (this));
	
	const volumeField = this.volumeField = element.querySelector ("#volume");
	
	const resultList = this.resultList =
		new ResultList (element.querySelector (".demand-calculator-results"));
	
	document.body.style.overflow = "visible";
	
	this.populateInputFields ();
	this.addInputFieldListeners ();
	
	await Product.loadModelData (element.dataset.modelDataUrl);
	
	if (Environment.FAST_PASS) {
		/*
		*/
		window.setTimeout (async _ => {
			this.selectGroup ({currentTarget: groupButtons [0]});
			 DemandCalculatorGallery.sharedInstance.jumpToInput ("iswaterpermeable");
			// DemandCalculatorGallery.sharedInstance.jumpToInput ("stonewidth");
			// DemandCalculatorGallery.sharedInstance.jumpToInput ("jointswidth");
			// DemandCalculatorGallery.sharedInstance.jumpToInput ("thickness");
			
		}, 125);
		
		window.setTimeout (_ => {
			this.closeOverlay ();
			
		}, 750);
		
		/*
		window.setTimeout (_ => {
			resultList.element.querySelector (".disclosure-button").click ();
			
		}, 1000);
		*/
		
		
	}
	
};

DemandCalculator.prototype.selectGroup = function (event) {
	let groupKey = this.groupKey;
	
	if (event) {
		event.preventDefault?. ();
		
		const groupButton = event.currentTarget;
		const groupLabel = groupButton.textContent;
		groupKey = this.groupKey = groupButton.dataset.groupKey;
		
		this.content.querySelector ("h2").textContent = groupLabel;
		
	}
	
	this.showsOverlay = true;
	
	const overlay = this.overlay;
	overlay.classList.remove ("hidden");
	
	this.startAnimation ("ShowOverlay", {direction: 1, rate: .025});
	
	const gallerySection = overlay.querySelector ("[data-class-name]").section;
	const gallery = gallerySection.gallery;
	
	gallery.viewOffset = gallery.currentViewOffset = 0;
	gallerySection.setViewSize (this.viewSize);
	gallery.advance ();
	
	const productsFromCurrentGroup = Product.filteredList ({
		group: groupKey
		
	})
	
	const calculationRuleMap = new Object ();
	let hasPermeableProducts, hasUnpermeableProducts;
	
	productsFromCurrentGroup.forEach (product => {
		calculationRuleMap [product.calculationRule] = true;
		
		const isWaterPermeable = product.isWaterPermeable;
		
		if (isWaterPermeable === false)
			hasUnpermeableProducts = true;
		else if (isWaterPermeable === true)
			hasPermeableProducts = true;
		
	});
	
	const filterByPermeability = this.filterByPermeability =
		!!(hasPermeableProducts && hasUnpermeableProducts);
	
	/*
	trace ("--- ", groupKey);
	trace ("calculation rules", JSON.stringify (calculationRuleMap));
	trace ("filterByPermeability", filterByPermeability);
	*/
	
	this.showInput ("iswaterpermeable", filterByPermeability);
	this.showInput ("height", !!calculationRuleMap ["Kontaktschicht und Kleber"]);
	this.showInput ("thickness", !!(calculationRuleMap ["Bettungsmörtel"] || calculationRuleMap ["Mauermörtel"]));
	
	const parameters = this.parameters;
	
	const resultList = this.resultList;
	
	resultList.populateWithProducts (
		Product.filteredList ({
			group: groupKey,
			isWaterPermeable: filterByPermeability ? parameters.isWaterPermeable : undefined
			
		})
		
	);
	
	const results = resultList.calculateFromParameters (parameters);
	
	this.volumeField.value = Math.round (results.volume * 100) / 100;
	
};

DemandCalculator.prototype.closeOverlay = function (event) {
	if (event)
		event.preventDefault ();
	
	if (!this.showsOverlay)
		return;
	this.showsOverlay = false;
	
	this.intro.classList.add ("hidden");
	this.backgroundElement.classList.add ("hidden");
	
	this.content.classList.remove ("hidden");
	
	this.startAnimation ("ShowOverlay", {direction: 0, rate: .05});
	
};

DemandCalculator.prototype.animateShowOverlay = function () {
	const state = this.updatedState ("ShowOverlay");
	let t = 1 - state.phase;
	t = 1 - t * t * t * t * t;
	
	const scale = Math.pow (state.direction > 0 ? .925 : .75, 1 - t);
	
	const overlay = this.overlay;
	
	function applyZoom (element) {
		element.style.transform = t < 1 ? "scale(" + scale + ")" : "";
		element.style.opacity = t * 1.5;
		element.style.display = t > 0 ? "" : "none";
		
	}
	
	applyZoom (overlay.firstElementChild);
	applyZoom (overlay.lastElementChild);
	
	overlay.style.display = t > 0 ? "" : "none";
	
	const mainElement = this.mainElement;
	if (t < 1)
		mainElement.classList.remove ("hidden");
	else
		mainElement.classList.add ("hidden");
	
};

DemandCalculator.prototype.reset = function (event) {
	if (event)
		event.preventDefault ();
	
	this.didReset = false;
	this.startAnimation ("Reset", {direction: 1, rate: .04, phase: 0});
	
};

DemandCalculator.prototype.animateReset = function () {
	const state = this.updatedState ("Reset");
	let t = state.phase;
	
	const mainElement = this.mainElement;
	if (t < .5) {
		t = 1 - t * 2;
		
	} else {
		t = (t - .5) * 2;
		
		if (!this.didReset) {
			this.didReset = true;
			
			this.intro.classList.remove ("hidden");
			this.backgroundElement.classList.remove ("hidden");
			
			this.content.classList.add ("hidden");
			
		}
		
	}
	
	t = 1 - t;
	t = 1 - t * t;
	
	mainElement.style.opacity = t;
	
};

DemandCalculator.prototype.showInput = function (name, doShow) {
	// trace ("> show input:", name, doShow);
	
	let inputMap = this.inputMap;
	if (!inputMap)
		inputMap = this.inputMap = new Object ();
	
	const showsInput =
		inputMap [name] == undefined ||
		inputMap [name];
	
	this.parameters ["shows" + name] = doShow;
	
	if (showsInput == doShow)
		return;
	
	inputMap [name] = doShow;
	
	let formRow = this.element.querySelector (".demand-calculator-form [id=" + name + "]");
	while (formRow) {
		if (doShow)
			formRow.removeAttribute ("disabled");
		else
			formRow.setAttribute ("disabled", "disabled");
		
		if (formRow.classList.contains ("form-select-row") ||
			formRow.classList.contains ("two-column-form-row") ||
			formRow.classList.contains ("w-full"))
			break;
		
		formRow = formRow.parentNode;
		
	}
	
	formRow.style.display = doShow ? "" : "none";
	
	const gallery = DemandCalculatorGallery.sharedInstance;
	switch (name) {
		case "iswaterpermeable":
			gallery.showSlide (name, doShow);
			break;
			
		default:
			gallery.showInput (name, doShow);
			break;
			
	}
	
};

DemandCalculator.prototype.addInputFieldListeners = function () {
	const parameters = this.parameters;
	
	const changeInputParameters = this.changeInputParameters.bind (this);
	
	for (const key in parameters) {
		const name = key.toLowerCase ();
		const inputs = document.querySelectorAll ("[name=" + name + "], [id=" + name + "]");
		
		inputs.forEach (input => {
			input.addEventListener ("input", changeInputParameters);
			input.addEventListener ("change", changeInputParameters);
			
		});
		
	}
	
	/*
	const galleryInputs = document.querySelectorAll (".gallery input, .gallery select");
	galleryInputs.forEach (input => {
		input.addEventListener ("focus", event => {
			trace ("focx=", input.outerHTML);
			
		});
		
	});
	*/
	
};

DemandCalculator.prototype.changeInputParameters = function (event) {
	if (this.isPopulatingInputFields)
		return;
	
	const input = event.currentTarget;
	
	const name = input.id || input.name;
	
	const parameters = this.parameters;
	let didChangeIsWaterPermeable;
	
	if (input.nodeName == "SELECT" ||
		input.type == "radio") {
		
		const isWaterPermeable = input.value.indexOf ("undurch") < 0;
		if (parameters.isWaterPermeable != isWaterPermeable) {
			didChangeIsWaterPermeable = true;
			parameters.isWaterPermeable = isWaterPermeable;
			
		}
		
	} else {
		for (const key in parameters) {
			if (name == key.toLowerCase ())
				parameters [key] = parseFloat (input.value) || 0;
			
		}
		
	}
	
	const resultList = this.resultList;
	
	if (didChangeIsWaterPermeable) {
		resultList.populateWithProducts (
			Product.filteredList ({
				group: this.groupKey,
				isWaterPermeable: this.filterByPermeability ? parameters.isWaterPermeable : undefined
				
			})
			
		);
		
	}
	
	resultList.calculateFromParameters (parameters);
	
	this.populateInputFields ();
	
};

DemandCalculator.prototype.populateInputFields = function () {
	if (this.isPopulatingInputFields)
		return;
	this.isPopulatingInputFields = true;
	
	const parameters = this.parameters;
	
	for (const key in parameters) {
		const value = parameters [key];
		const name = key.toLowerCase ();
		const inputs = document.querySelectorAll ("[name=" + name + "], [id=" + name + "]");
		
		inputs.forEach ((input, i) => {
			if (input.nodeName == "INPUT") {
				if (input.type == "radio") {
					input.checked = i > 1 ? !value : !!value;
					
				} else {
					if (input != document.activeElement)
						input.value = value;
					
				}
				
			} else if (input.nodeName == "SELECT") {
				const options = input.children;
				options [0].selected = value;
				options [1].selected = !value;
				
			}
			
		});
		
	}
	
	this.isPopulatingInputFields = false;
	
};

//
// DemandCalculatorGallerySection extends GallerySection
//

export const DemandCalculatorGallerySection = function (context) {
	GallerySection.apply (this, arguments);
	
};

window.DemandCalculatorGallerySection = DemandCalculatorGallerySection;

DemandCalculatorGallerySection.prototype = Object.create (GallerySection.prototype);

DemandCalculatorGallerySection.prototype.getGalleryConstructor = function () {
	return DemandCalculatorGallery;
	
};

//
// DemandCalculatorGallery extends Gallery
//

export const DemandCalculatorGallery = function (context) {
	Gallery.apply (this, arguments);
	
	DemandCalculatorGallery.sharedInstance = this;
	
};

DemandCalculatorGallery.prototype = Object.create (Gallery.prototype);

DemandCalculatorGallery.prototype.getSlideConstructor = function () {
	return window.DemandCalculatorAnimation;
	
};

DemandCalculatorGallery.prototype.parseChildren = async function () {
	if (!window.DemandCalculatorAnimation) {
		const module = await import ("./DemandCalculatorAnimation.js");
		window.DemandCalculatorAnimation = module.DemandCalculatorAnimation;
		
	}
	
	Gallery.prototype.parseChildren.apply (this, arguments);
	
	const element = this.element;
		
	const children = element.querySelectorAll (".gallery__slide");
	this.children = Array.from (children);
	children.forEach ((child, index) => {
		child.originalIndex = index;
		child.originalParent = child.parentNode;
		
	});
	
	const slides = this.slides;
	slides.forEach ((slide, i) => {
		const slideElement = slide.element;
		
		slideElement.controller = slide;
		
		slideElement.querySelector (".button.secondary:first-child")?.addEventListener ("click", event => {
			this.advanceInDirection (-1, true);
			
		});
		slideElement.querySelector (".button:last-child").addEventListener ("click", event => {
			if (i == slides.length - 1)
				DemandCalculator.sharedInstance.closeOverlay ();
			else
				this.advanceInDirection (1, true);
			
		});
		
		slideElement.querySelectorAll ("input, select").forEach (input => {
			const clickableElement = input.type == "radio" ? input.nextElementSibling : input;
			
			clickableElement.addEventListener ("mousedown", event => {
				event.stopPropagation ();
				
			});
			clickableElement.addEventListener ("click", event => {
				event.stopPropagation ();
				
				if (input.type == "radio") { // safari fix
					input.parentNode.parentNode.querySelectorAll ("input").forEach (
						otherInput => otherInput.checked = otherInput == input
						
					);
					DemandCalculator.sharedInstance.changeInputParameters ({currentTarget: input});
					
				} else {
					event.preventDefault ();
					input.focus ();
					
				}
				
			});
			input.addEventListener ("blur", event => {
				slide.setVisualizationFocus ();
				
			}, true);
			input.addEventListener ("focus", event => {
				this.setViewOffsetByIndex (slides.indexOf (slide));
				
				slide.setVisualizationFocus (input.name || input.id);
				
			}, true);
			
		});
		
		/*
		slideElement.querySelectorAll ("input[type=radio]").forEach ((radioButton, i) => {
			radioButton.addEventListener ("change", event => {
				const image = slideElement.querySelector ("img");
				image.src = image.src.replace (/(1.|2.)/, i + 1 + ".");
				
			});
			
		});
		*/
		
		const resizeObserver = new ResizeObserver (function (entries) {
			this.updateLayout (true);
			
		}.bind (this));
		resizeObserver.observe (slideElement);
		
	});
	
};

DemandCalculatorGallery.prototype.slideForInput = function (name, doFocus) {
	let slide;
	
	this.children.forEach (child => {
		if (!slide) {
			let element = child.querySelector ("[name=" + name + "], [id=" + name + "]");
			if (element && doFocus) {
				const input = element;
				window.setTimeout (_ => input.focus (), 125);
				
			}
			while (element) {
				if (element.classList.contains ("gallery__slide")) {
					slide = element;
					break;
					
				}
				element = element.parentNode;
				
			}
			
		}
		
	});
	return slide;
	
};

DemandCalculatorGallery.prototype.showSlide = function (name, doShow) {
	// trace ("> show slide:", name, doShow);
	
	const children = this.children;
	const slide = this.slideForInput (name);
	
	const element = this.element;
	const slides = this.slides;
	
	if (doShow) {
		let nextSlide;
		children.forEach (child => {
			if (!nextSlide)
				if (child.originalIndex > slide.originalIndex)
					nextSlide = child;
				
		});
		slide.originalParent.insertBefore (
			slide, nextSlide
			
		);
		
		const index = Array.from (element.querySelectorAll (".gallery__slide")).indexOf (slide);
		slides.splice (index, 0, slide.controller);
		
	} else {
		slide.remove ();
		
		const index = children.indexOf (slide);
		slides.splice (index, 1);
		
	}
	
	this.numSlides = slides.length;
	
	this.viewOffset = this.currentViewOffset = 0;
	this.updateViewOffsetForVariableContent ();
	
};

DemandCalculatorGallery.prototype.showInput = function (name, doShow) {
	// trace ("gallery show input", name+":", doShow);
	
	this.children.forEach (child => {
		let input = child.querySelector ("[id=" + name + "]");
		
		if (input) {
			const displayStyle = doShow ? "" : "none";
			
			input.parentNode.style.display = displayStyle;
			input.parentNode.previousElementSibling.style.display = displayStyle;
			
		}
		
	});
	
};

DemandCalculatorGallery.prototype.jumpToInput = function (name) {
	const slide = this.slideForInput (name, true);
	const index = Array.from (this.element.querySelectorAll (".gallery__slide")).indexOf (slide);
	
	this.setViewOffsetByIndex (index, true);
	
};

DemandCalculatorGallery.prototype.boundedViewOffset = function (viewOffset) {
	return Math.max (0, Math.min ((this.numSlides - 1) * (this.viewSize [0] + this.spacing), viewOffset));
	
};

DemandCalculatorGallery.prototype.dragHorizontal = function (scrollingController) {
	var deltaX = scrollingController.delta.x;
	this.removeRunLoopHandler ("processSliding");
	
	var viewSize = this.viewSize;
	var dragDelta = Math.min (
		viewSize [0] / 2, Gallery.DRAG_DELTA
		
	);
	
	const currentViewOffset = this.currentViewOffset;
	if (Math.abs (deltaX) >= dragDelta && !this.scrollThrough && currentViewOffset == this.boundedViewOffset (currentViewOffset))
		this.advanceInDirection (deltaX < 0 ? -1 : 1);
	else
		this.viewOffset = this.currentViewOffset = this.startViewOffset + deltaX;
	
	this.updateViewOffset ();
	
	this.markActivity ();
	
};

Gallery.prototype.setViewOffsetByIndex = function (index, dontAnimate) {
	const viewOffset = this.viewOffset;
	const targetViewOffset = this.viewOffsetForSlideIndex (index);
	
	if (viewOffset != targetViewOffset) {
		if (dontAnimate) {
			this.viewOffset = this.currentViewOffset = targetViewOffset;
			this.removeRunLoopHandler ("processSliding");
			this.updateViewOffset ();
			
		} else {
			this.viewOffset = targetViewOffset;
			this.slidingInertia = .85;
			this.maxScrollSpeed = 4;
			this.accelerationDescription = undefined;
			this.addRunLoopHandler ("processSliding");
			
		}
		
	}
	
	this.dispatchEvent ("advance");

};

DemandCalculatorGallery.prototype.updateLayout = function (noResize) {
	var slides = this.slides;
	var slide = slides?. [0];
	if (!slide)
		return;
	
	const transformElement = this.element.parentNode.parentNode;
	const transformStyle = transformElement.style.transform;
	if (transformStyle)
		transformElement.style.transform = "";
	
	slide.element.style.display = "";
	
	var containerElement = this.contentContainer.element;
	var containerWidth = Math.round (containerElement.offsetWidth);
	if (!containerWidth) {
		slides.forEach (slide => {
			if (slide.isAwake)
				slide.sleep ();
			
		});
		return;
		
	}
	
	const selfBounds = containerElement.getBoundingClientRect ();
	
	var viewSize;
	
	viewSize = [
		containerWidth,
		Math.round (containerElement.offsetHeight)
		
	];
	
	const site = Site.sharedInstance;
	const columnWidth = site.columnWidth;
	const gutterWidth = site.gutterWidth;
	
	let slideWidth;
	let spacing;
	
	if (containerWidth < 768) {
		spacing = Site.sharedInstance.gutterWidth
		slideWidth = Math.min (containerWidth * .75, Math.max (
			640 - 10,
			Math.ceil ((containerWidth - spacing * 2) / 3)
			
		));
		
	} else if (containerWidth < 1440) {
		spacing = Site.sharedInstance.gutterWidth * .5;
		slideWidth = Math.ceil (columnWidth * 10 + gutterWidth * 9);
		
	} else {
		spacing = Site.sharedInstance.gutterWidth * .5;
		slideWidth = Math.ceil (columnWidth * 8 + gutterWidth * 7);
		
	}
	
	this.spacing = spacing;
	
	// trace ("-- containerWidth",containerWidth);
	// trace ("slideWidth", slideWidth, "spacing", spacing);
	
	viewSize [0] = slideWidth;
	
	let fullWidth = 0;
	var maxHeight = 0;
	var slides = this.slides;
	
	for (var i = slides.length; i--;) {
		var slide = slides [i];
		var slideElement = slide.element;
		
		var displayStyle = slideElement.style.display;
		
		if (displayStyle)
			slideElement.style.display = "";
		
		slideElement.style.width = slideWidth + "px";
		slideElement.style.height = "auto";
		
		const overlay = slideElement.querySelector (".gallery__slide--text-overlay");
		const overlayBounds = overlay ? overlay.getBoundingClientRect () : undefined;
		
		var slideSize = slide.contentSize = [
			slideWidth,
			overlayBounds ? overlayBounds.bottom - selfBounds.top : slideElement.offsetHeight
			
		];
		
		fullWidth += slideWidth + spacing;
		
		if (displayStyle)
			slideElement.style.display = displayStyle;
		
		maxHeight = Math.max (maxHeight, slideSize [1]);
		
	}
	
	if (fullWidth <= selfBounds.width) {
		if (!this.preventScroll) {
			this.preventScroll = true;
			element.classList.add ("gallery--no-scroll");
			
		}
		
	} else {
		if (this.preventScroll) {
			this.preventScroll = false;
			element.classList.remove ("gallery--no-scroll");
			
		}
		
	}
	
	this.fullWidth = fullWidth;
	viewSize [1] = maxHeight;
	
	this.setViewSize (viewSize, noResize);
	
	const navigationElement = this.navigationElement;
	if (navigationElement)
		navigationElement.style.height = Math.round (slideWidth * .35 * 2) + "px";
	
	if (transformStyle)
		transformElement.style.transform = transformStyle;
	
	this.finishSetup ();
	
};

DemandCalculatorGallery.prototype.updateViewOffsetForVariableContent = function () {
	const slides = this.slides;
	
	const stageWidth = this.getStage ().size [0];
	
	var viewSize = this.viewSize;
	var viewWidth = viewSize [0];
	var spacing = this.spacing;
	
	var viewOffset = this.currentViewOffset;
	
	const boundedViewOffset = this.boundedViewOffset (viewOffset);
	viewOffset = (viewOffset + boundedViewOffset * 3) / 4;
	
	var cursor = -viewOffset;
	
	slides.forEach (slide => {
		var percentage = cursor / stageWidth;
		
		const position = Math.round (cursor + stageWidth * .5 - viewWidth * .5);
		
		if (Math.abs (percentage) < 1) {
			slide.element.style.transform = "translateX(" + Math.round (position) + "px)";
			
			if (!slide.isLoading)
				slide.startLoading ();
			
			slide.loadingPriority = Math.abs (cursor + viewOffset);
			
			if (!slide.isAwake) {
				slide.setAlpha (1);
				slide.element.style.visibility = "";
				slide.awake ();
				
			}
			
		} else {
			if (slide.isAwake)
				slide.sleep ();
			
			if (!slide.element.style.visibility)
				slide.element.style.visibility = "hidden";
			
		}
		
		slide.percentage = percentage;
		
		slide.setIsActive (Math.abs (cursor / viewWidth) < .5);
		
		cursor += (slide.contentSize || viewSize) [0] + spacing;
		
	});
	
	this.dispatchEvent ("updateViewOffset");
	
};

//
// ResultList
//

const ResultList = function (element) {
	this.element = element;
	
	const table = this.table = element.querySelector ("tbody");
	
	const headlinePrototype = this.headlinePrototype = element.querySelector (".demand-calculator-result-headline");
	headlinePrototype.remove ();
	headlinePrototype.classList.remove ("hidden");
	
	const detailDisclosurePrototype = this.detailDisclosurePrototype = element.querySelector (".demand-calculator-result-detail-disclosure");
	detailDisclosurePrototype.remove ();
	
	const itemPrototype = this.itemPrototype = element.querySelector (".demand-calculator-result-item");
	itemPrototype.remove ();
	
};

ResultList.locale = document.documentElement.getAttribute ("lang");

ResultList.prototype.populateWithProducts = function (products) {
	this.products = products;
	
	const table = this.table;
	table.innerHTML = "";
	
	const headlinePrototype = this.headlinePrototype;
	const itemPrototype = this.itemPrototype;
	
	const locale = ResultList.locale;
	
	let currentHeadline;
	
	products.forEach (product => {
		if (currentHeadline != product.headline) {
			currentHeadline = product.headline;
			
			const headlineElement = headlinePrototype.cloneNode (true);
			headlineElement.querySelector ("h4").textContent = currentHeadline;
			
			const disclosureButton = headlineElement.querySelector (".disclosure-button");
			disclosureButton.addEventListener ("click", event => {
				headlineElement.classList.toggle ("unopened");
				const isOpen = !headlineElement.classList.contains ("unopened");
				
				let item = disclosureButton.parentNode.parentNode;
				while ((item = item.nextElementSibling) &&
					!item.classList.contains ("demand-calculator-result-headline")) {
					item.classList.toggle ("hidden", !isOpen);
					
				}
				disclosureButton.querySelectorAll ("span").forEach (span => span.classList.toggle ("hidden"));
				
			});
			
			table.appendChild (headlineElement);
			
			/*
			const detailDisclosureElement = this.detailDisclosurePrototype.cloneNode (true);
			detailDisclosureElement.querySelector ("a").addEventListener ("click", event => {
				let item = detailDisclosureElement;
				while ((item = item.nextElementSibling) &&
					!item.classList.contains ("demand-calculator-result-headline")) {
					item.querySelector ("ul").classList.toggle ("hidden");
					
				}
				detailDisclosureElement.querySelectorAll ("span").forEach (span => span.classList.toggle ("hidden"));
				
			});
			
			table.appendChild (detailDisclosureElement);
			*/

			const detailDisclosureButton = headlineElement.querySelector (".detail-disclosure-button");
			detailDisclosureButton.addEventListener ("click", event => {
				let item = detailDisclosureButton.parentNode.parentNode;
				while ((item = item.nextElementSibling) &&
					!item.classList.contains ("demand-calculator-result-headline")) {
					item.querySelector ("ul")?.classList.toggle ("hidden");
					
				}
				detailDisclosureButton.querySelectorAll ("span").forEach (span => span.classList.toggle ("hidden"));
				
			});
			
		}
		
		let itemElement = product.itemElement;
		if (itemElement === undefined) {
			itemElement = product.itemElement = itemPrototype.cloneNode (true);
			
			const productLink = itemElement.querySelector (".text-link");
			if (product.productPageURL)
				productLink.href = product.productPageURL;
			else
				productLink.removeAttribute ("href");
			
			const nameElement = productLink.querySelector ("h3");
			nameElement.textContent = product.name;
			
			const sizeElement = nameElement.parentNode.nextElementSibling;
			sizeElement.innerHTML = // (Environment.FAST_PASS ? product.calculationRule + "<br>" : "") +
				sizeElement.innerHTML.replace (
				"[[unitSize]]", product.getNumericalProperty ("unitSize").toLocaleString (locale) + " " + product.unit
				
			).replace (
				"[[demandPerSqareMeter]]", product.getNumericalProperty ("demandPerSqareMeter").toLocaleString (locale) + " " + product.unit
				
			);
			
			product.getFeatureList ().then (featureList => {
				if (featureList)
					sizeElement.nextElementSibling.innerHTML = featureList.innerHTML;
				else
					sizeElement.nextElementSibling.remove ();
				
			});
			
		}
		
		if (itemElement)
			table.appendChild (itemElement);
		
	});
	
};

ResultList.prototype.calculateFromParameters = function (parameters) {
	// trace ("calc", JSON.stringify (parameters));
	
	const lfm =
		(1000 / (parameters.stoneWidth + parameters.jointsWidth)) +
		(1000 / (parameters.stoneLength + parameters.jointsWidth));
	// trace ("lfm", lfm);
	
	const volume = parameters.jointsWidth * parameters.jointsDepth * lfm / 1000;
	// trace ("volume", volume);
	
	const locale = ResultList.locale;
	
	this.products.forEach (product => {
		const itemElement = product.itemElement;
		if (itemElement) {
			const unitSize = product.getNumericalProperty ("unitSize");
			
			const density = product.getNumericalProperty ("density");
			
			let demandPerSqareMeter;
			let demandKilogram;
			
			switch (product.calculationRule) {
				case "Fugenmörtel":
					demandPerSqareMeter = volume * density;
					demandKilogram = parameters.area * demandPerSqareMeter;
					break;
					
				case "Bettungsmörtel":
					demandPerSqareMeter = parameters.height * density;
					demandKilogram = parameters.area * demandPerSqareMeter;
					break;
					
				case "Kontaktschicht und Kleber":
				case "Mauermörtel":
					demandPerSqareMeter = parameters.thickness * density;
					demandKilogram = parameters.area * demandPerSqareMeter;
					break;
					
				default:
					trace ("calculation rule", product.calculationRule, "not implemented");
					
			}
			
			const demandWeight = parameters.area * demandPerSqareMeter;
			const unitDemand = Math.round (demandWeight / unitSize);
			
			const countElement = itemElement.querySelector ("h3");
			if (!ResultList.countTextTemplate)
				ResultList.countTextTemplate = countElement.textContent;
			countElement.textContent = ResultList.countTextTemplate.replace ("[[unitCount]]", unitDemand.toLocaleString (locale));
			
			const weightElement = itemElement.querySelector ("p");
			if (!ResultList.weightTextTemplate)
				ResultList.weightTextTemplate = weightElement.textContent;
			weightElement.textContent = ResultList.weightTextTemplate.replace ("[[unitsWeight]]", (unitDemand * unitSize).toLocaleString (locale) + " " + product.unit);
			
		}
		
	});
	
	return {lfm, volume};
	
};

ResultList.prototype.scrollToHeadline = function (headline) {
	let targetHeadlineElement;
	
	this.element.querySelectorAll ("h4").forEach (headlineElement => {
		if (!targetHeadlineElement) {
			if (headlineElement.textContent == headline)
				targetHeadlineElement = headlineElement;
			
		}
		
	});
	
	const bodyBounds = document.body.getBoundingClientRect ();
	const headlineBounds = targetHeadlineElement.getBoundingClientRect ();
	
	let targetOffset = headlineBounds.top - bodyBounds.top - 55;
	
	Site.sharedInstance.scrollToOffset (targetOffset);
	
};
